import React, {useState} from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody, Button, Box, Text, VStack
} from "@chakra-ui/react";
import {DatabaseInfo, DatabaseProperty} from "@app/core-app/app/data/notion/DatabaseInfo";
import {DropdownSelector} from "../../atoms/DropdownSelector";
import {PropertyValueSelector} from "./PropertyValueSelector";
import {DefaultNotionProperty} from "@app/core-app/app/data/notion/properties";
import {InboxDbConfig} from "@app/core-app/app/data/profile";
import {event} from "../../../../services/analytics";
import {NotionPropertiesService} from "@app/core-app/app/service/notion-properties";


export const DefaultPropertiesModal = ({database, onNewProperty, inboxConfiguration}: {
  database: DatabaseInfo,
  onNewProperty: (data: DefaultNotionProperty) => Promise<any>,
  inboxConfiguration: InboxDbConfig

}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [selectedProperty, setSelectedProperty] = useState<DatabaseProperty | null>(null)
  const [propertyValue, setPropertyValue] = useState(null);


  const onOpen = () => {
    event({action: "open_add_default_property_modal", params: {}})
    setIsOpen(true);
  }

  const onClose = () => {
    setIsOpen(false);
  };


  const existingDefaultPropertyNames = inboxConfiguration.defaultPropertiesConfig
    ?.properties
    ?.map(x => x.name) ?? []

  const existingDefaultPropertyNamesSet = new Set(existingDefaultPropertyNames)

  const propertiesNames = database.propertiesObjects
    .filter(x => {
      if (existingDefaultPropertyNamesSet.has(x.name)) {
        return false
      }

      if (x.type === "created_time" || x.type === "last_edited_time") {
        return false
      }

      return true
    })
    .map(x => x.name)

  const handleSaveProperty = () => {
    if (selectedProperty) {
      event({action: "add_default_property", params: {}})

      const updateObject = {
        name: selectedProperty.name,
        type: selectedProperty.type,
        defaultValue: propertyValue
      };
      setLoading(true)
      onNewProperty(updateObject)
        .then(() => {
          onClose();
        })
        .finally(() => {
          setSelectedProperty(null)
          setPropertyValue(null)
          setLoading(false)
        })
    }
  };
  return (<>
    <Button onClick={() => onOpen()} colorScheme={"blue"} size={"sm"} variant={"solid"}>
        Setup new default property
    </Button>
    <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
      <ModalOverlay/>
      <ModalContent>
        <ModalHeader>Add new default property</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
          <VStack alignItems={"start"} w={'full'} spacing={2}>
            <Box w={'full'}>
              <Text color={"gray.500"} fontWeight={"medium"} my={2}>Property Name:</Text>
              <DropdownSelector
                value={selectedProperty?.name}
                options={propertiesNames}
                onChange={(dataObject) => {
                  const value = dataObject?.value
                  if (value) {
                    const property = database.propertiesObjects.find(x => x.name === value)
                    if (property) {
                      setSelectedProperty(property)
                    }
                  }
                }}/>


            </Box>
            {selectedProperty?.type && <Box w={'full'}>
              <Text color={"gray.500"} fontWeight={"medium"} my={2}>Property Type:</Text>
              <Text color={"gray.700"}>{selectedProperty.type}</Text>
            </Box>}

            {selectedProperty && <Box w={'full'}>
              <Text color={"gray.500"} fontWeight={"medium"} my={2}>Default value:</Text>
              <PropertyValueSelector property={selectedProperty} onValueChange={value => setPropertyValue(value)}/>
            </Box>}

            <Button isLoading={loading}
              isDisabled={!NotionPropertiesService.supportedDefaultFields.includes(selectedProperty?.type)}
              colorScheme={"blue"} size={"md"} w={'full'} my={4}
              onClick={handleSaveProperty}>Set default value</Button>
          </VStack>


        </ModalBody>
      </ModalContent>
    </Modal>
  </>
  );
};
